import * as React from "react";
import { FormattedMessage } from "react-intl";
import { Image } from "react-bootstrap";

// declare the center element -- but seriously, FIXME: don't use <center>
declare global {
    namespace JSX {
        interface IntrinsicElements {
            center: any;
        }
    }
}

export function ErrorPage() {
    return (
        <div>
            <div className="error-page">
                <center>
                    <Image src="/ordercapture/uidispatcher/static/app/assets/images/error.png" alt="oops" responsive />
                    <div className="page-text">
                        <h1>
                            <FormattedMessage id="ERROR_LOADING_COMPONENT_MESSAGE" />
                        </h1>
                    </div>
                </center>
            </div>
        </div>
    );
}
